import cn from 'classnames';
import React from 'react';
import styles from './heading2.module.scss';

export interface TitleProps {
  bold?: boolean;
  color?: 'primary' | 'secondary' | 'green' | 'grey';
  children: any;
  id?: string | null;
}

const Title: React.FC<TitleProps> = ({
  children,
  color = 'green',
  bold = false,
  id = null
}) => (
  <h2
    id={id}
    className={cn(styles.heading2, styles[color], { [styles.bold]: bold })}
  >
    {children}
  </h2>
);

export default Title;
